import { X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { useDowntimeBanner } from '@/lib/hooks';

export function DowntimeBanner() {
  const [show, setShow] = useDowntimeBanner();

  if (!show) return null;

  return (
    <div className="bg-primary flex min-h-12 items-center justify-between gap-4 px-4 py-1 text-white">
      <div className="text-sm font-bold">
        Scheduled maintenance  Nov 5th from 8pm - 8:30.  During this period this
        application will have limited availability
      </div>
      <Button aria-label="Dismiss" onClick={() => setShow(false)} size="icon">
        <X />
      </Button>
    </div>
  );
}
